export default class CalculatedOneXTwoFromScoresModel {
  public home: number = null;
  public draw: number = null;
  public away: number = null;
}
